//linking UTC timezones to GMT timezones, since moments.js have no aliases for that.
//links according to https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
//NOTE: tried using moment.tz.link() function from documentation, but it overrides existing links from moments-timezone-10-years-range.js and simply doesn't work. So using this trick instead.
moment.tz._links['utc+1'] = "etc_gmt-1";
moment.tz._links['utc+2'] = "etc_gmt-2";
moment.tz._links['utc+3'] = "etc_gmt-3";
moment.tz._links['utc+4'] = "etc_gmt-4";
moment.tz._links['utc+5'] = "etc_gmt-5";
moment.tz._links['utc+6'] = "etc_gmt-6";
moment.tz._links['utc+7'] = "etc_gmt-7";
moment.tz._links['utc+8'] = "etc_gmt-8";
moment.tz._links['utc+9'] = "etc_gmt-9";
moment.tz._links['utc+10'] = "etc_gmt-10";
moment.tz._links['utc+11'] = "etc_gmt-11";
moment.tz._links['utc+12'] = "etc_gmt-12";
moment.tz._links['utc+13'] = "etc_gmt-13";
moment.tz._links['utc+14'] = "etc_gmt-14";
moment.tz._links['utc+0'] = "etc_gmt+0";
moment.tz._links['utc-1'] = "etc_gmt+1";
moment.tz._links['utc-2'] = "etc_gmt+2";
moment.tz._links['utc-3'] = "etc_gmt+3";
moment.tz._links['utc-4'] = "etc_gmt+4";
moment.tz._links['utc-5'] = "etc_gmt+5";
moment.tz._links['utc-6'] = "etc_gmt+6";
moment.tz._links['utc-7'] = "etc_gmt+7";
moment.tz._links['utc-8'] = "etc_gmt+8";
moment.tz._links['utc-9'] = "etc_gmt+9";
moment.tz._links['utc-10'] = "etc_gmt+10";
moment.tz._links['utc-11'] = "etc_gmt+11";
moment.tz._links['utc-12'] = "etc_gmt+12";

//Need to call .tz() on each Etc/GMT timezones for aliases to be caught.
for(let tz_utc_offset = -14; tz_utc_offset <= 12; tz_utc_offset++){
    let timeZoneName = "Etc/GMT" + ((tz_utc_offset < 0) ? "" : "+") + tz_utc_offset;
    moment.tz(timeZoneName);
}
